<template>
	<div class="app-dialog-manager">
		<component
			v-for="(dialog, i) in openDialogs"
			:is="dialog.component"
			v-bind="dialog.dialogProps"
			v-on="dialog.dialogListeners"
			:key="i"
		/>
	</div>
</template>

<script>
/*
AppDialogManager is a component that is meant to display dialogs as they are described in 
the "dialogs store" which can be programmatically changed from anywhere in the code
using 'app-dialog-manager-service.js'.
It is meant to exist in the highest of DOM node possible and live throughout the 
lifecycle of the app so it is used only once and rendered only once.
*/
import { mapGetters } from 'vuex';
import { getOpenDialogs } from '@/store/modules/dialogs/getters';

export default {
	name: 'AppDialogManager',
	components: {},
	computed: {
		...mapGetters([getOpenDialogs.fullPath]),
		openDialogs() {
			return this[getOpenDialogs.fullPath];
		},
	},
};
</script>

<style scoped lang="scss">
.app-dialog-manager {
}
</style>
